/** Tenant cards /metering/tenant/list (list.vue) */
export default {
  tenantListPage: {
    phTenantIdName: 'Tenant name / ID',
    phTenantStatus: 'Tenant status',
    phTenantType: 'Tenant type',
    phPayType: 'Payment mode',
    phLabels: 'Labels',
    tenantType0: 'Tenant',
    tenantType1: 'Public area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    optStatusNormal: 'Active',
    optStatusCancelled: 'Closed',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExpand: 'More filters',
    btnCollapse: 'Fewer filters',
    btnExport: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    exportSubAccounts: 'Export sub-accounts',
    expElectricAccount: 'Electricity account',
    expWaterAccount: 'Water account',
    subAccountsSheetName: 'Tenant sub-accounts',
    msgNoSubAccountsExport: 'No valid sub-accounts to export',
    sectionTitle: 'Tenant cards',
    btnAdd: 'Add',
    batchSettings: 'Batch',
    batchUrge: 'Payment reminder',
    batchArrearsTrip: 'Arrears trip',
    batchPayMode: 'Pay mode',
    batchWarnQuota: 'Alert quota',
    batchBillingPlan: 'Billing plan',
    batchDownloadCodes: 'Download tenant codes',
    batchManualDebit: 'Batch debit',
    selectAll: 'Select all',
    selectedCount: '{n} selected',
    sortCreateTimeDesc: 'Created (newest)',
    sortCreateTimeAsc: 'Created (oldest)',
    sortMeterDesc: 'Electricity balance (high→low)',
    sortMeterAsc: 'Electricity balance (low→high)',
    sortWaterDesc: 'Water balance (high→low)',
    sortWaterAsc: 'Water balance (low→high)',
    sortNameAz: 'Name (A–Z)',
    sortNameZa: 'Name (Z–A)',
    viewTable: 'Table',
    viewCard: 'Cards',
    colTenantId: 'Tenant ID',
    tipClickCopy: 'Click to copy',
    colTenantName: 'Tenant name',
    avatarCharFallback: 'T',
    colQrcode: 'QR code',
    colLabels: 'Labels',
    colDedicatedMeters: 'Total devices',
    colDeviceTipMeter: 'Electric meter',
    colDeviceTipWater: 'Water meter',
    colDeviceTipAir: 'Air conditioner',
    colMeterBalanceYuan: 'Electricity account (¥)',
    colWaterBalanceYuan: 'Water account (¥)',
    colTenantStatus: 'Status',
    colCreateTime: 'Created',
    colPayType: 'Payment',
    optPayPrepaid: 'Prepaid',
    optPayPostpaid: 'Postpaid',
    colActions: 'Actions',
    btnDetail: 'Details',
    btnManualDeduct: 'Debit',
    btnUrge: 'Remind',
    btnMore: 'More',
    btnEdit: 'Edit',
    btnManualRecharge: 'Top up',
    emptyNoData: 'No data',
    cardAvatarFallback: 'T',
    cardDedicatedMeters: 'Total devices:',
    cardDeviceTipMeter: 'Electric meter',
    cardDeviceTipWater: 'Water meter',
    cardDeviceTipAir: 'Air conditioner',
    cardTenantBalance: 'Total balance:',
    cardPayType: 'Payment:',
    cardMeterAccount: 'Electricity:',
    cardWaterAccount: 'Water:',
    cardTenantStatus: 'Status:',
    cardCreatedAt: 'Created:',
    balanceStatus_1: 'OK',
    balanceStatus_2: 'Low balance',
    balanceStatus_3: 'Overdue',
    balanceStatus_unknown: 'Unknown',
    msgFetchTenantsFail: 'Failed to load tenants',
    msgNothingToCopy: 'Nothing to copy',
    msgTenantIdCopied: 'Tenant ID copied',
    msgCopyFail: 'Copy failed',
    msgNoDataExport: 'No data to export',
    expColId: 'Tenant ID',
    expColName: 'Tenant name',
    expColDevices: 'Total devices',
    expColPayType: 'Payment',
    expColMeterBalance: 'Electricity balance (¥)',
    expColWaterBalance: 'Water balance (¥)',
    expColStatus: 'Status',
    expColCreated: 'Created',
    exportSheetName: 'Tenants',
    exportFileNamePrefix: 'tenants_',
    msgExportSuccessN: 'Exported {n} row(s)',
    msgExportFail: 'Export failed',
    warnNoSelectedExport: 'Select tenants to export first',
    exporting: 'Exporting...',
    successExportedLimit: 'Exported first {count} row(s) (total {total} matched the filter; exceeds the 2000 limit per export)',
    msgNoAddPerm: 'No permission to add',
    msgNoDeductPerm: 'No permission to debit',
    msgSelectTenantsFirst: 'Select tenants first',
    msgGenQrcodeProgressN: 'Generating {n} QR code(s)…',
    qrcodeDownloadPrefix: 'tenant-qrcode-',
    unnamed: 'unnamed',
    msgDownloadNQrcodes: 'Downloaded {n} QR code(s)',
    msgDownloadFail: 'Download failed',
    msgPageNoData: 'No data on this page',
    confirmExportAllQrcodeBody: 'Export QR codes for all {n} tenant(s) on this page?',
    titleTip: 'Notice',
    btnConfirm: 'OK',
    btnCancel: 'Cancel',
    msgExportNQrcodes: 'Exported {n} QR code(s)',
    msgExportQrcodeFail: 'Export failed',
    msgQrcodeGenFail: 'QR code generation failed',
    qrCanvasLabelTenantId: 'Tenant ID:',
    qrCanvasLabelTenantName: 'Tenant name:',
    qrCanvasScanHint: 'Scan to bind',
    msgNoViewPerm: 'No permission to view',
    msgNoEditPerm: 'No permission to edit',
    msgNoUrgePerm: 'No permission to remind',
    confirmUrgeBody: 'Send payment reminder to {name}?',
    msgUrgeSuccess: 'Reminder sent',
    msgUrgeFail: 'Reminder failed',
    msgNoRechargePerm: 'No permission to top up',
    resourceTooltipTitle: 'Bound resources ({n})'
  },
  /** Dialogs on tenant list (copy only; API payloads unchanged) */
  tenantDialogs: {
    qrcode: {
      title: 'QR code',
      loading: 'Generating QR code…',
      bindTipPrimary: 'Ask the tenant to scan this QR code to bind',
      bindTipLink: 'Link: ',
      copyLink: 'Copy link',
      download: 'Download QR code',
      close: 'Close',
      msgGenFail: 'Failed to generate QR code. Please try again.',
      msgCopyOk: 'Link copied to clipboard',
      msgCopyFail: 'Copy failed. Please copy manually.',
      msgDownloadOk: 'QR code downloaded',
      msgDownloadFail: 'Download failed. Please try again.',
      msgNotReady: 'QR code is not ready yet. Please wait.'
    },
    recharge: {
      title: 'Manual top-up',
      labelBizType: 'Top-up type',
      labelAmount: 'Amount',
      labelRemark: 'Remark',
      phAmount: 'Enter amount',
      phRemark: 'Enter remark',
      electric: 'Electricity',
      water: 'Water',
      cancel: 'Cancel',
      confirm: 'OK',
      submitting: 'Processing…',
      ruleBizType: 'Select top-up type',
      ruleAmount: 'Enter amount',
      ruleAmountMin: 'Amount must be at least ¥0.01',
      ruleRemark: 'Enter remark',
      confirmTitle: 'Notice',
      confirmBody: 'Confirm top-up for {type} ¥{amount}?',
      msgSuccess: 'Top-up succeeded',
      msgFail: 'Top-up failed'
    },
    deduct: {
      title: 'Manual debit',
      labelUseType: 'Debit type',
      labelBillDate: 'Bill date',
      labelAmount: 'Amount',
      labelRemark: 'Remark',
      phBillDate: 'Select bill date',
      phAmount: 'Enter debit amount',
      phRemark: 'Enter remark',
      electric: 'Electricity',
      water: 'Water',
      cancel: 'Cancel',
      confirm: 'OK',
      submitting: 'Processing…',
      ruleUseType: 'Select debit type',
      ruleBillDate: 'Select bill date',
      ruleAmount: 'Enter debit amount',
      ruleAmountMin: 'Amount must be at least ¥0.01',
      ruleRemark: 'Enter remark',
      confirmTitle: 'Notice',
      confirmBody: 'Confirm debit of {type} ¥{amount}?',
      msgSuccess: 'Debit succeeded',
      msgFail: 'Debit failed'
    },
    batchDebit: {
      title: 'Batch debit',
      electric: 'Electricity',
      water: 'Water',
      labelUseType: 'Debit type',
      labelBillDate: 'Bill date',
      labelRemark: 'Remark',
      labelDetail: 'Debit lines',
      phBillDate: 'Select bill date',
      phRemark: 'Enter remark',
      uploadBtn: 'Upload',
      downloadTpl: 'Download template',
      tipFormat: 'Upload .xlsx file',
      tipAmount: 'Note: only rows with debit amount > 0 are accepted',
      cancel: 'Cancel',
      confirm: 'OK',
      submitting: 'Submitting…',
      ruleUseType: 'Select debit type',
      ruleBillDate: 'Select bill date',
      ruleRemark: 'Enter remark',
      msgExceed: 'At most one file',
      msgBadExt: 'Please upload .xlsx or .xls',
      msgParsed: 'Parsed {n} row(s)',
      msgParseFail: 'Failed to parse file',
      msgNoManager: 'Manager information is missing',
      msgTenantListFail: 'Failed to load tenants',
      msgTplOk: 'Template downloaded',
      msgTplFail: 'Failed to download template',
      msgNoFile: 'Please upload the detail file',
      msgNoPositive: 'At least one row must have debit amount > 0',
      confirmTitle: 'Notice',
      confirmBody: 'Submit batch debit?',
      msgSubmitOk: 'Success',
      sheetDetail: 'Lines',
      sheetFail: 'Errors',
      tplFileName: 'debit-template.xlsx',
      failFileName: 'debit-errors.xlsx',
      colTenantId: 'Tenant ID',
      colTenantName: 'Tenant name',
      colAmount: 'Debit amount',
      colError: 'Error'
    },
    add: {
      titleCreate: 'Add tenant',
      titleEdit: 'Edit tenant',
      sectionBasic: 'Basic info',
      sectionFee: 'Billing',
      sectionContact: 'Contact',
      labelName: 'Tenant name',
      phName: 'Enter tenant name',
      phSelectName: 'Select tenant name',
      labelArea: 'Leased area',
      phArea: 'Enter leased area',
      labelResources: 'Resources',
      phResources: 'Select resources',
      resourceBound: 'Bound',
      resourceBoundBy: 'This resource is bound to tenant: {name}',
      labelTenantType: 'Tenant type',
      labelPayType: 'Payment mode',
      labelPostPayComment: 'Postpaid remark',
      phPostPayComment: 'Enter postpaid remark',
      payTypePrepaid: 'Prepaid',
      payTypePostpaid: 'Postpaid',
      tenantType0: 'Tenant',
      tenantType1: 'Common area',
      tenantType2: 'Other',
      tenantType3: 'Solar',
      collectMeter: 'Electricity billing',
      collectWater: 'Water billing',
      yes: 'Yes',
      no: 'No',
      alarm1: 'Alert threshold 1',
      alarm2: 'Alert threshold 2',
      overdraw: 'Overdraft limit',
      yuan: 'CNY',
      phAmount: '0.00',
      phoneLabel: 'Phone {n}',
      phPhone: 'Enter mobile number',
      addPhone: 'Add phone',
      cancel: 'Cancel',
      confirm: 'OK',
      saving: 'Saving…',
      ruleNameRequired: 'Enter tenant name',
      ruleNameMax: 'Tenant name cannot exceed 50 characters',
      ruleAreaRequired: 'Enter leased area',
      rulePhone: 'Enter a valid mobile number',
      ruleTenantTypeRequired: 'Please select tenant type',
      rulePostPayCommentRequired: 'Enter postpaid remark',
      msgEditOk: 'Saved',
      msgCreateOk: 'Created',
      msgRenterLoadFail: 'Failed to load Ming Yuan customers',
      msgResourceLoadFail: 'Failed to load Ming Yuan resources',
      msgFail: 'Operation failed'
    }
  }
}
